module.exports = __webpack_public_path__ + "static/media/Ayush_Ambhorkar.acc77dca.jpg";